import React, { Component } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

class Button extends Component {
  render () {
    let classes = ['Button', 'Button-' + this.props.align]
    if (this.props.classNames !== '') {
      classes.push(this.props.classNames)
    }
    if (this.props.disabled === true) {
      classes.push("Button-Disabled")
    }
    return (
      <button
        type={this.props.type}
        style={this.props.style}
        className={classes.join(' ')}
        onClick={this.props.onClick}>{this.props.children}</button>
    )
  }
}

Button.defaultProps = {
  onClick: () => {},
  disabled: false,
  type: 'button',
  classNames: '',
  align: 'left'
}

Button.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  align: PropTypes.string,
  classNames: PropTypes.string,
  style: PropTypes.object
}
export default Button
